/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import {
  get_applicant_hiring_progress_action,
  get_applicant_comments_list_action,
  create_applicant_comment_action,
  delete_applicant_comment_action,
  update_applicant_comment_action,
  update_applicant_profile_status_kanboard_hiring_manager_action,
  user_meta_data_action,
  create_applicant_offer_terms_action,
  get_applicant_offer_terms_action,
} from "../../../../redux/_actions";
import { useLocation } from "react-router-dom";
import { showWarningMessage } from "../../../../_uiComponents/ShowMessageSnack";

function useHiringProcess(props) {
  const [stageLoading, setStageLoading] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [openCommentInput, SetOpenCommentInput] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [deleteCommentModal, setdeleteCommentModal] = useState(false);
  const [deleteCommentId, setDeleteCommentId] = useState(null);
  const [editCommentIndex, setEditCommentIndex] = useState(null);
  const [editCommentText, setEditCommentText] = useState(null);
  const [editCommentLoading, setEditCommentLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(null);
  const [activeStage, setActiveStage] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isOfferTermsModalOpen, setIsOfferTermsModalOpen] = useState(false);
  const [offerTermsFormData, setOfferTermsFormData] = useState({});
  const [offerTermsAdded, setOfferTermsAdded] = useState(false);
  const [offerTermsAddedLoading, setOfferTermsAddedLoading] = useState(false);

  const dispatch = useDispatch(props);
  const location = useLocation(props);

  const hiringProgressInfoData = useSelector(
    (state) => state.get_applicant_hiring_progress_reducer.data
  );
  const getCommentsData = useSelector(
    (state) => state.get_applicant_comments_list_reducer.data
  );

  const { applicantProfileData } = useSelector(
    (state) => state.get_applicant_profile_info_reducer
  );
  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);

  const { applicantOfferTermsData } = useSelector(
    (state) => state.get_applicant_offer_terms_reducer
  );

  useEffect(() => {
    callUserMetaApi();
  }, []);

  useEffect(() => {
    if (userMetaData?.id) {
      let user_role = userMetaData?.role;

      setUserType(user_role);
    }
  }, [userMetaData]);

  useEffect(() => {
    if (currentTab) {
      let applicantId = location?.state?.applicantId;
      getCommentList(applicantId, currentTab);
    }
  }, [currentTab]);

  useEffect(() => {
    let applicantId = location?.state?.applicantId;
    if (applicantId) {
      getHiringProgressData(applicantId);
    }
  }, []);

  useEffect(() => {
    if (applicantProfileData?.data) {
      let offered =
        applicantProfileData?.data && applicantProfileData.data?.is_job_offered;
      setOfferTermsAdded(offered);

      if (offered) {
        callOfferTermsApi();
      }
    }
  }, [applicantProfileData]);

  useEffect(() => {
    if (applicantOfferTermsData?.data) {
      setOfferTermsFormData(applicantOfferTermsData?.data);
    }
  }, [applicantOfferTermsData]);

  const callUserMetaApi = async () => {
    await dispatch(user_meta_data_action());
  };

  let getHiringProgressData = async (id) => {
    const data = await dispatch(get_applicant_hiring_progress_action(id));
    let tabSelect =
      data &&
      data.filter((item) => item.is_current_stage) &&
      data.filter((item) => item.is_current_stage)[0];
    setCurrentTab(tabSelect && tabSelect.stage);
    setActiveStage(tabSelect && tabSelect.stage);
  };

  let getCommentList = async (id, stage) => {
    await dispatch(get_applicant_comments_list_action(id, stage));
  };

  let changeHiringProcessHandler = async (data) => {
    let jobApplication = data && data.job_application;
    let hiringStage = data && data.stage;
    let FormData = {};
    if (hiringStage === "applied") {
      FormData = { ...FormData, interview_stage: "assessment" };
    } else if (hiringStage === "assessment") {
      FormData = { ...FormData, interview_stage: "interview" };
    } else if (hiringStage === "interview") {
      FormData = { ...FormData, interview_stage: "offer" };
    } else if (hiringStage === "offer") {
      FormData = { ...FormData, interview_stage: "hired" };
    }

    setStageLoading(true);
    await dispatch(
      update_applicant_profile_status_kanboard_hiring_manager_action(
        jobApplication,
        FormData
      )
    );

    getHiringProgressData(jobApplication);
    setStageLoading(false);
  };

  let rejectApplicantHandler = async (data) => {
    let jobApplication = data && data.job_application;

    let FormData = { interview_stage: "rejected" };

    setStageLoading(true);
    await dispatch(
      update_applicant_profile_status_kanboard_hiring_manager_action(
        jobApplication,
        FormData
      )
    );

    getHiringProgressData(jobApplication);
    setStageLoading(false);
  };

  let openCommentInputHandler = () => {
    SetOpenCommentInput(true);
  };
  let createCommentHandler = async (data) => {
    if (commentText !== "") {
      setCommentLoading(true);
      let commentData = {
        content: commentText,
        interview_stage: data && data.stage,
        commented_by: userMetaData?.id,
        candidate_job_application: data && data.job_application,
      };
      await dispatch(create_applicant_comment_action(commentData));
      setCommentText("");

      getCommentList(data && data.job_application, data && data.stage);
      setCommentLoading(false);
    } else {
      alert("please fill comment");
    }
  };

  let deleteCommentModalHandler = (item) => {
    setdeleteCommentModal(true);
    setDeleteCommentId(item.id);
  };
  let deleteCommentHandler = async () => {
    await dispatch(delete_applicant_comment_action(deleteCommentId));
    getCommentList(location?.state?.applicantId, currentTab);
    setdeleteCommentModal(false);
    setDeleteCommentId(null);
  };

  let handleDeleteModalClose = () => {
    setdeleteCommentModal(false);
  };

  let editCommentHandler = async (data) => {
    let FormData = {
      content: editCommentText,
      interview_stage: data && data.interview_stage,
    };
    setEditCommentLoading(true);
    await dispatch(update_applicant_comment_action(data && data.id, FormData));
    setEditCommentLoading(false);

    setEditCommentIndex(null);
    getCommentList(
      data && data.candidate_job_application,
      data && data.interview_stage
    );
  };

  let currentTabHandler = (tabName) => {
    // setActiveStage(tabName);
    setCurrentTab(tabName);
  };

  const callOfferTermsApi = async () => {
    await dispatch(
      get_applicant_offer_terms_action(
        applicantProfileData?.data && applicantProfileData.data?.id
      )
    );
  };
  const onMakeOfferClick = async () => {
    let data = offerTermsFormData;
    if (data?.amount !== null && data?.terms_conditions !== null) {
      data["candidate_job_application"] =
        applicantProfileData?.data && applicantProfileData.data?.id;
      setOfferTermsAddedLoading(true);
      await dispatch(create_applicant_offer_terms_action(data));
      setOfferTermsAddedLoading(false);
    } else showWarningMessage("Please enter amount and Offer Terms");
    setIsOfferTermsModalOpen(false);
    setOfferTermsAdded(true);
  };

  const onAddOfferTermsClick = () => {
    setOfferTermsFormData({});
    setIsOfferTermsModalOpen(!isOfferTermsModalOpen);
  };
  const onOfferTermsFormDataChange = (e) => {
    let data = offerTermsFormData;
    data[e.target.name] = e.target.value;
    setOfferTermsFormData(data);
  };

  const onCommentCancleClick = async (data) => {
    SetOpenCommentInput(false);
    setCommentText("");
  };

  const onEditCommentCancleClick = async (data) => {
    setEditCommentIndex(null);
  };

  return {
    stageLoading,
    commentLoading,
    openCommentInput,
    commentText,
    deleteCommentModal,
    deleteCommentId,
    editCommentIndex,
    editCommentText,
    editCommentLoading,
    currentTab,
    activeStage,
    userType,
    hiringProgressInfoData,
    isOfferTermsModalOpen,
    offerTermsFormData,
    offerTermsAdded,
    offerTermsAddedLoading,

    currentTabHandler,
    editCommentHandler,
    handleDeleteModalClose,
    deleteCommentHandler,
    deleteCommentModalHandler,
    createCommentHandler,
    changeHiringProcessHandler,
    rejectApplicantHandler,
    openCommentInputHandler,
    setEditCommentText,
    setCommentText,
    getCommentsData,
    setEditCommentIndex,
    onOfferTermsFormDataChange,
    onAddOfferTermsClick,
    onMakeOfferClick,
    onCommentCancleClick,
    onEditCommentCancleClick,
  };
}
export default useHiringProcess;
